import { Container, Stack, Text, Title } from "@mantine/core";
import { openContextModal } from "@mantine/modals";
import {
  IconCalendarEvent,
  IconTrophy,
  IconUserPlus,
} from "@tabler/icons-react";
import {
  useBoard,
  useIsBoardAdmin,
  useIsBoardReferee,
} from "../../common/boards/board.hooks";
import { Swords } from "../../common/icons/swords";
import StepOptionButton from "../common/StepOptionButton";
import { EventType } from "../../common/events/event.schema";
import { useEventStore } from "../../common/events/event.store";
import { trackEvent } from "../../common/analytics";

const EmptyBoard = () => {
  const isAdmin = useIsBoardAdmin();
  const isRef = useIsBoardReferee();
  const { board } = useBoard();
  const addMember = () => {
    trackEvent("open_modal_add_member", { board: board?._id });
    openContextModal({
      title: "Add your first member",
      modal: "addMember",
      innerProps: {},
    });
  };
  const addMatch = () => {
    trackEvent("open_modal_add_match", { board: board?._id });
    openContextModal({
      title: "Add your first match",
      modal: "addMatch",
      fullScreen: true,
      innerProps: { creatable: isAdmin || (isRef && board?.refereeAddMembers) },
    });
  };
  const addEvent = (eventType: EventType) => {
    useEventStore.getState().clear();
    useEventStore.getState().setFormState({ eventType });
    trackEvent("open_modal_add_event", { board: board?._id });
    openContextModal({
      title: "Add your first event",
      modal: "addEvent",
      fullScreen: true,
      innerProps: {
        creatable: isAdmin || (isRef && board?.refereeAddMembers),
      },
    });
  };
  if (!isRef) return <Title order={3}>This board is empty</Title>;
  const hasMembers = !!board?.memberCount && board.memberCount > 0;
  const hasMatches = !!board?.matchCount && board.matchCount > 0;
  const hasEvents = !!board?.tournamentCount && board.tournamentCount > 0;
  return (
    <Container size="xs" mt={20}>
      <Stack>
        <Title ta="center" order={3}>
          Welcome to your board
        </Title>
        <Text mb={20} ta="center">
          To get started simply:
        </Text>
        {isAdmin && !hasMembers && (
          <StepOptionButton
            title="Create a member"
            description="Add a member to your new board"
            onClick={() => addMember()}
            icon={<IconUserPlus />}
          />
        )}
        {!hasMatches && (
          <StepOptionButton
            title="Add a casual match"
            description='Add your first casual match "quick adding" members as needed'
            onClick={() => addMatch()}
            icon={<Swords size={20} />}
          />
        )}
        {!hasEvents && (
          <StepOptionButton
            title="Run a quick tournament"
            description='Create and run your first tournament, "quick adding" members as needed'
            onClick={() => addEvent(EventType.TOURNAMENT)}
            icon={<IconTrophy />}
          />
        )}
        {isAdmin && (
          <StepOptionButton
            title="Schedule a class"
            description="Run a class or training session"
            onClick={() => addEvent(EventType.CLASS)}
            icon={<IconCalendarEvent />}
          />
        )}
      </Stack>
    </Container>
  );
};
export default EmptyBoard;
